// Adapter GTM/GA4 — consome window.dataLayer (criado pelo componente GoogleTagManager).
// Schema GA4 ecommerce: { event, ecommerce: { items[], value, currency, transaction_id } }.
import { isGtmEnabled } from "../config";

const CURRENCY = "BRL";

// Campos escalares extras do schema GA4 ecommerce (shipping_tier para add_shipping_info;
// promotion_*/creative_* para select_promotion). Repassados ao objeto ecommerce quando
// presentes no payload.
const ECOMMERCE_EXTRA = [
  "shipping_tier",
  "promotion_id",
  "promotion_name",
  "creative_name",
  "creative_slot",
];

function toGa4Items(items = []) {
  return (items || []).map((it) => ({
    item_id: it.id,
    item_name: it.nome,
    price: it.preco,
    quantity: it.quantidade,
    ...(it.categoria ? { item_category: it.categoria } : {}),
  }));
}

export function sendGtm(meta, payload) {
  if (!isGtmEnabled()) return;

  const dataLayer = window.dataLayer;

  if (meta.schema === "ecommerce") {
    // Limpa o objeto ecommerce anterior antes de cada evento (recomendação GA4).
    dataLayer.push({ ecommerce: null });
    const ecommerce = {
      currency: payload.currency || CURRENCY,
      ...(payload.value != null ? { value: payload.value } : {}),
      ...(payload.transaction_id ? { transaction_id: payload.transaction_id } : {}),
      ...(payload.coupon ? { coupon: payload.coupon } : {}),
      items: toGa4Items(payload.items),
    };
    ECOMMERCE_EXTRA.forEach((k) => {
      if (payload[k] != null) ecommerce[k] = payload[k];
    });
    dataLayer.push({ event: meta.ga4, event_id: payload.event_id, ecommerce });
    return;
  }

  // simple / custom: empurra os parâmetros crus (sem o array de items).
  const rest = { ...payload };
  delete rest.items;
  dataLayer.push({ ...rest, event: meta.ga4 });
}

export default sendGtm;
